var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1155",
    d: "M6.5 1C7.5878 1 8.65116 1.32257 9.55563 1.92692C10.4601 2.53126 11.1651 3.39025 11.5813 4.39524C11.9976 5.40023 12.1065 6.5061 11.8943 7.573C11.6821 8.63989 11.1583 9.6199 10.3891 10.3891C9.6199 11.1583 8.63989 11.6821 7.573 11.8943C6.5061 12.1065 5.40023 11.9976 4.39524 11.5813C3.39025 11.1651 2.53126 10.4601 1.92692 9.55563C1.32257 8.65116 1 7.5878 1 6.5C1 5.04131 1.57946 3.64236 2.61091 2.61091C3.64236 1.57946 5.04131 1 6.5 1V1Z",
    stroke: "#898B8F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1154",
    d: "M6.49902 3.56186V6.78909H9.44464",
    stroke: "#898B8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.89d6389182f0002a3aff2740e8208ba0.svg";
export { ForwardRef as ReactComponent };